import React, { Component, Fragment } from 'react'
import Picture from '../../components/Picture'
import DemoFormPartners from '../../components/site/Forms/DemoFormPartners'

export default function HeroPartners(props) {

    return (
        <div className={`new-main-banner-v2 new-hero new-hero-purple-bg hero-v2`}>
            <div className='container'>
                <div className="column">
                    <div className="wrapper-logos">
                        <img src="/images/logo_mercos_footer.png" alt="Logomarca Mercos" className='hero-logos' /> + <img src={props.companyLogo} alt="" className='hero-logos' />

                    </div>
                    <div className='title-wrapper'>
                        {props.overtitle ? <div className='label-small'>{props.overtitle}</div> : ""}
                        <h1 className='title'>{props.title}</h1>
                    </div>
                    <div className='main-subheading-container'>
                        <h2 className='description'>
                            {props.description}
                        </h2>
                    </div>
                    <Picture noWebp
                        className='hero-img-partner-mobile hide-desktop'
                        src="/images/site/partners/hero-img-partners.png"
                        alt='Mercos, sistema de vendas, emissão de pedidos e e-commerce B2B'
                    />
                    {props.cta}


                </div>
                <div className="column desktop-only">

                </div>
            </div>

            <Picture noWebp
                className='hero-img-partner hide-mobile'
                src="/images/site/partners/hero-img-partners.png"
                alt='Mercos, sistema de vendas, emissão de pedidos e e-commerce B2B'
            />
            <div className="full-width-white-fill"></div>
        </div>
    )
}


// WEBPACK FOOTER //
// /usr/src/site-blog/src/blocks/Hero/HeroPartners.jsx